// extracted by mini-css-extract-plugin
module.exports = {"loader":"_8d57c0","loader__text-light":"_4a3163","loader__text-gray":"_5c9bdb","loader__text-pink":"_60cd4d"};